import ValoresRepository from "@/services/ValoresRepository";

export default {
  namespaced: true,
  state: {
    listaCultivos: [],
  },
  mutations: {
    setListaCultivos(state, listaCultivos) {
      state.listaCultivos = listaCultivos;
    },

    clearListaCultivos(state) {
      state.listaCultivos = [];
    },
  },
  actions: {
    async fetchListaCultivos({ state, commit }) {
      if (state.listaCultivos && state.listaCultivos.length > 0) {
        return;
      }

      let listaCultivos = await ValoresRepository.listaCultivos();
      commit("setListaCultivos", listaCultivos);
    },

    async clearListaCultivos({ commit }) {
      commit("clearListaCultivos");
    },
  },
};
